import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import { messageFormatValues } from '#client/pages/ProductLanding/utils/messageFormatValues';

import * as Styled from './SubHeader.style';

const getVisibleReviews = (isMobile, reviews = []) => {
  if (!isMobile) {
    return reviews;
  }

  return reviews.filter((review) => review.showOnMobile);
};

const pResolver = (chunks) => <Styled.SubheaderText>{chunks}</Styled.SubheaderText>;

function SubHeader({ text, intro, logo, reviews = [], align }) {
  const { sizes } = useBreakpoints();
  const { formatMessage } = useIntl();

  const visibleReviews = getVisibleReviews(sizes.isMobile, reviews);

  return (
    <Styled.SubHeaderContainer sx={align ? { alignItems: align } : undefined}>
      <Stack gap={2}>
        <Text>
          <FormattedMessage
            id={text}
            values={{
              ...messageFormatValues,
              p: pResolver,
            }}
          />
        </Text>
        {intro && (
          <Text>
            <FormattedMessage
              id={intro}
              values={{
                p: pResolver,
              }}
            />
          </Text>
        )}
      </Stack>

      {logo.src && (
        <Styled.PartnerSection>
          <Styled.PartnerImage src={logo.src} alt={logo.alt ? formatMessage({ id: logo.alt }) : logo.alt} />
          <Styled.PartnerReviewBlanks>
            {visibleReviews.map((review) =>
              review.src ? (
                <Styled.PartnerImage
                  key={review.src}
                  src={review.src}
                  alt={review.alt ? formatMessage({ id: review.alt }) : review.alt}
                />
              ) : (
                <Text size="md" weight="medium" key={review.text}>
                  <FormattedMessage id={review.text} />
                </Text>
              ),
            )}
          </Styled.PartnerReviewBlanks>
        </Styled.PartnerSection>
      )}
    </Styled.SubHeaderContainer>
  );
}

SubHeader.propTypes = {
  text: PropTypes.string.isRequired,
  intro: PropTypes.string,
  align: PropTypes.string,
  logo: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }).isRequired,
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
      showOnMobile: PropTypes.bool,
      text: PropTypes.string,
    }),
  ),
};

export default SubHeader;
